// extracted by mini-css-extract-plugin
export default {"post":"Post_post__-VFh0","title":"Post_title__G171B"};